// L'Oréal staff have their own L'Oréal Luxe / DPGP apps: gps-app is not for them — except
// the Flagship desk, which uses no dedicated app.
const LOREAL_EMAIL = /@loreal\.com$/i;
const FLAGSHIP_SERVICE_DESK_ID = 403;

interface AppAdoptionAudienceInput {
  platform: 'ios' | 'android' | 'desktop';
  inNativeApp: boolean;
  email: string | null;
  serviceDeskId: number | null;
  hasMobileApp: boolean;
  isImpersonating: boolean;
}

export const isAppAdoptionAudience = ({
  platform,
  inNativeApp,
  email,
  serviceDeskId,
  hasMobileApp,
  isImpersonating,
}: AppAdoptionAudienceInput): boolean => {
  const usesLorealApp = LOREAL_EMAIL.test((email ?? '').trim()) && serviceDeskId !== FLAGSHIP_SERVICE_DESK_ID;
  return platform !== 'desktop' && !inNativeApp && !hasMobileApp && !isImpersonating && !usesLorealApp;
};
